import {
  INVEST_FUND_INIT,
  INVEST_FUND_SUCCESS,
  INVEST_FUND_FAILED,
} from "./constants";
const initialState = {
  investedFunds: [],
  fundLoading: false,
};

export default function InvestedFunds(state = initialState, action) {
  switch (action.type) {
    case INVEST_FUND_INIT:
      return { ...state, fundLoading: true };
    case INVEST_FUND_SUCCESS:
      return {
        ...state,
        fundLoading: false,
        investedFunds:
          action.payload.page === 1
            ? action.payload.items
            : [...state.investedFunds, ...action.payload.items],
      };
    case INVEST_FUND_FAILED:
      return { ...state, fundLoading: false };
    default:
      return state;
  }
}
